
// Check if we're in development mode
const isDevelopment = import.meta.env.DEV;

// Function to get API URL - use proxy in development, direct URLs in production
const getApiUrl = (envVar, fallbackUrl, proxyPath) => {
  if (isDevelopment) {
    return `/api/${proxyPath}`;
  }
  return envVar || fallbackUrl;
};

export const API_ENDPOINTS = {
  REGISTER: getApiUrl(
    import.meta.env.VITE_REGISTER_URL, 
    'https://a09dwdqjwg.execute-api.ap-south-1.amazonaws.com/default/register',
    'register'
  ),
  LOGIN: getApiUrl(
    import.meta.env.VITE_LOGIN_URL,
    'https://00rb8n024l.execute-api.ap-south-1.amazonaws.com/default/login',
    'login'
  ),
  DASHBOARD: getApiUrl(
    import.meta.env.VITE_DASHBOARD_URL,
    'https://uy5tuctiye.execute-api.ap-south-1.amazonaws.com/default/dashboard-fetch',
    'dashboard-fetch'
  ),
  CREATE_PROJECT: getApiUrl(
    import.meta.env.VITE_CREATE_PROJECT_URL,
    'https://umxllmal76.execute-api.ap-south-1.amazonaws.com/default/create-project',
    'create-project'
  ),
  EDIT_COLLABORATORS: getApiUrl(
    import.meta.env.VITE_EDIT_COLLABORATORS_URL,
    'https://nffvd7rdy7.execute-api.ap-south-1.amazonaws.com/default/edit-collaborators',
    'edit-collaborators'
  ),
  SEND_OTP: getApiUrl(
    import.meta.env.VITE_SEND_OTP_URL,
    'https://x4lzxbwrdc.execute-api.ap-south-1.amazonaws.com/default/send-otp',
    'send-otp'
  ),
  VERIFY_OTP: getApiUrl(
    import.meta.env.VITE_VERIFY_OTP_URL,
    'https://1fozweql3h.execute-api.ap-south-1.amazonaws.com/default/verify-otp',
    'verify-otp'
  ),
  RESET_PASSWORD: getApiUrl(
    import.meta.env.VITE_RESET_PASSWORD_URL,
    'https://7jxij91g2e.execute-api.ap-south-1.amazonaws.com/default/reset-password',
    'reset-password'
  ),
  UPDATE_PASSWORD: getApiUrl(
    import.meta.env.VITE_UPDATE_PASSWORD_URL,
    'https://4832dxgs78.execute-api.ap-south-1.amazonaws.com/default/update-password',
    'update-password'
  ),
  REQUEST_PROJECT_PASSWORD_UPDATE: getApiUrl(
    import.meta.env.VITE_REQUEST_PROJECT_PASSWORD_UPDATE_URL,
    'https://0r612gnaia.execute-api.ap-south-1.amazonaws.com/default/request-project-password-update',
    'request-project-password-update'
  ),
  COMPLETE_PROJECT_PASSWORD_UPDATE: getApiUrl(
    import.meta.env.VITE_COMPLETE_PROJECT_PASSWORD_UPDATE_URL,
    'https://srfpt0k69b.execute-api.ap-south-1.amazonaws.com/default/complete-project-password-update',
    'complete-project-password-update'
  ),
  START_PROJECT: getApiUrl(
    import.meta.env.VITE_START_PROJECT_URL,
    'https://bduim4ahuh.execute-api.ap-south-1.amazonaws.com/default/Start-Project',
    'Start-Project'
  ),
  FEEDBACK: getApiUrl(
    import.meta.env.VITE_FEEDBACK_URL,
    'https://acv4006kuf.execute-api.ap-south-1.amazonaws.com/default/feedback-api',
    'feedback'
  )
};

export const STORAGE_KEYS = {
  JWT: 'jwt',
  SEND_OTP_JWT: 'send_otp_jwt',
  VERIFY_OTP_JWT: 'verify_otp_jwt',
  USER_PROFILE: 'userprofile',
  PROJECTS: 'projects'
};

export const POLLING_INTERVAL = 30000; // 30 seconds

// Debug log to verify endpoints are loaded
